import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { BEGIN, FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { DRIVER_LOG_MODULE } from '../../configs/moduleNames';

export const LOAD_DRIVER_LOG_LIST = '_LOAD_DRIVER_LOG_LIST';
export const LOAD_DRIVER_LOG_LIST_ALL = 'LOAD_DRIVER_LOG_LIST_ALL';
export const LOAD_DRIVER_LOG_BY_ID = '_LOAD_DRIVER_LIST';
export const LOAD_TRANSPORT_LIST = '_LOAD_TRANSPORT_LIST';
export const LOAD_TRANSPORT_LIST_BY_ID = '_LOAD_TRANSPORT_LIST_BY_ID';
export const LOAD_ORDER_SERVICE_BY_ID = '_LOAD_ORDER_SERVICE_LIST';
export const LOAD_ORDER_SERVICE_LIST = '_LOAD_ORDER_SERVICE_BY_ID';

export const loadDriverLogList = createDeferredAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST);
export const loadDriverLogSuccessful = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST + SUCCESSFUL);
export const loadDriverLogBegin = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST + BEGIN);
export const loadDriverLogFailed = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST + FAILED);

export const loadDriverLogListAll = createDeferredAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST_ALL);
export const loadDriverLogAllSuccessful = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST_ALL + SUCCESSFUL);
export const loadDriverLogAllBegin = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST_ALL + BEGIN);
export const loadDriverLogAllFailed = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_LIST_ALL + FAILED);

export const loadDriverCardById = createDeferredAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_BY_ID);
export const loadDriverCardByIdSuccessful = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_BY_ID + SUCCESSFUL);
export const loadDriverCardByIdFailed = createAction(DRIVER_LOG_MODULE + LOAD_DRIVER_LOG_BY_ID + FAILED);
